<template>
  <b-modal
    centered
    size="md"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <h4>Set Synch Day of Month</h4>
      <p>Order Item: <strong>{{ order_item_name }}</strong></p>

      <b-row>
        <b-col>
          <label>Day of Month (1-31):</label>
          <b-form-select
            v-model="selected_day"
            :options="dayOptions"
          ></b-form-select>
        </b-col>
      </b-row>

      <small class="text-muted" v-if="current_day">
        Current synch day: <strong>{{ current_day }}</strong>
      </small>

      <hr />
      <b-row>
        <b-col>
          <b-btn @click="save" variant="success" :disabled="!selected_day">
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn v-if="current_day" @click="clearDay" variant="danger">
            Clear Day
          </b-btn>
          <b-btn @click="cancelModal" variant="warning">
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    order_item_id: String,
    current_day: Number,
    order_item_name: String
  },
  data() {
    return {
      selected_day: null,
      dayOptions: [
        { value: null, text: 'Select a day...' },
        ...Array.from({ length: 31 }, (_, i) => ({
          value: i + 1,
          text: `Day ${i + 1}`
        }))
      ]
    };
  },
  watch: {
    show(val) {
      if (val && this.current_day) {
        this.selected_day = this.current_day;
      } else if (val) {
        this.selected_day = null;
      }
    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    save() {
      this.updateSynchDay(this.selected_day);
    },
    clearDay() {
      this.updateSynchDay(null);
    },
    updateSynchDay(day) {
      let dayValue = day !== null ? day : null;
      let data = {
        query: `
          mutation {
            res: OrderItemUpdateSynchDate (
              order_item_id: ${parseInt(this.order_item_id)},
              synch_day: ${dayValue}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.cancelModal();
      });
    },
    cancelModal() {
      this.selected_day = null;
      this.close();
    }
  }
};
</script>

<style scoped>
h4 {
  margin-bottom: 16px;
  color: #2d3748;
  font-size: 1.25rem;
  font-weight: 600;
}

p {
  margin-bottom: 20px;
  color: #4a5568;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #2d3748;
}

.form-control {
  font-size: 1rem;
}

.text-muted {
  display: block;
  margin-top: 12px;
  font-size: 0.875rem;
  color: #718096;
}

hr {
  margin: 20px 0;
  border-color: #e2e8f0;
}

.btn {
  margin-right: 8px;
}
</style>
